import React from 'react'

import type { MenuHeadersIncludesData } from 'routes/Menu/domains/brand/types'

import { GradientInfoHeader } from '../GradientInfoHeader'
import { WaveLinkHeaderContainer } from '../LinkHeaderContainer'

type MerchandisingHeaderProps = {
  header?: MenuHeadersIncludesData | null
}

export const MerchandisingHeader = ({ header }: MerchandisingHeaderProps) => {
  if (!header) {
    return null
  }

  const { gradientColor, backgroundColor, color, headerImage, image, description, link } =
    header.attributes

  switch (header.type) {
    case 'gradient-info-header':
      return (
        <GradientInfoHeader
          gradientColor={gradientColor}
          color={color}
          headerImage={headerImage}
          image={image}
          description={description}
        />
      )
    case 'wave-link-header':
      return (
        <WaveLinkHeaderContainer
          backgroundColor={backgroundColor}
          color={color}
          headerImage={headerImage}
          description={description}
          link={link}
        />
      )
    default:
      return null
  }
}
